__turbopack_context__.v({
  "campusListSection": "CampusLocationSelector-module__LYkztW__campusListSection",
  "campusListSectionInline": "CampusLocationSelector-module__LYkztW__campusListSectionInline",
  "confirmCampusButton": "CampusLocationSelector-module__LYkztW__confirmCampusButton",
  "emptyState": "CampusLocationSelector-module__LYkztW__emptyState",
  "exploreOnlineButton": "CampusLocationSelector-module__LYkztW__exploreOnlineButton",
  "inlineFunctionalUI": "CampusLocationSelector-module__LYkztW__inlineFunctionalUI",
  "inlineRoot": "CampusLocationSelector-module__LYkztW__inlineRoot",
  "locationButton": "CampusLocationSelector-module__LYkztW__locationButton",
  "locationButtonIcon": "CampusLocationSelector-module__LYkztW__locationButtonIcon",
  "modalBody": "CampusLocationSelector-module__LYkztW__modalBody",
  "modalCloseButton": "CampusLocationSelector-module__LYkztW__modalCloseButton",
  "modalContent": "CampusLocationSelector-module__LYkztW__modalContent",
  "modalDialog": "CampusLocationSelector-module__LYkztW__modalDialog",
  "modalDragHandle": "CampusLocationSelector-module__LYkztW__modalDragHandle",
  "modalDragHandleArea": "CampusLocationSelector-module__LYkztW__modalDragHandleArea",
  "modalFooter": "CampusLocationSelector-module__LYkztW__modalFooter",
  "modalHeader": "CampusLocationSelector-module__LYkztW__modalHeader",
  "modalInner": "CampusLocationSelector-module__LYkztW__modalInner",
  "modalShell": "CampusLocationSelector-module__LYkztW__modalShell",
  "modalTitle": "CampusLocationSelector-module__LYkztW__modalTitle",
  "modalTitleBlock": "CampusLocationSelector-module__LYkztW__modalTitleBlock",
  "noResultsBody": "CampusLocationSelector-module__LYkztW__noResultsBody",
  "noResultsCopy": "CampusLocationSelector-module__LYkztW__noResultsCopy",
  "noResultsEmptyState": "CampusLocationSelector-module__LYkztW__noResultsEmptyState",
  "noResultsTitle": "CampusLocationSelector-module__LYkztW__noResultsTitle",
  "searchButton": "CampusLocationSelector-module__LYkztW__searchButton",
  "searchClearButton": "CampusLocationSelector-module__LYkztW__searchClearButton",
  "searchInput": "CampusLocationSelector-module__LYkztW__searchInput",
  "searchInputRoot": "CampusLocationSelector-module__LYkztW__searchInputRoot",
  "searchInputSection": "CampusLocationSelector-module__LYkztW__searchInputSection",
  "searchInputWrapper": "CampusLocationSelector-module__LYkztW__searchInputWrapper",
  "searchRow": "CampusLocationSelector-module__LYkztW__searchRow",
  "selectorButton": "CampusLocationSelector-module__LYkztW__selectorButton",
  "selectorInline": "CampusLocationSelector-module__LYkztW__selectorInline",
});
